import { render, staticRenderFns } from "./PaiementFour.vue?vue&type=template&id=22897f71&"
import script from "./PaiementFour.vue?vue&type=script&lang=js&"
export * from "./PaiementFour.vue?vue&type=script&lang=js&"
import style0 from "./PaiementFour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports